import { PlusOutlined } from '@ant-design/icons';
import { StoreModelType } from '@smx-ui-model/types';
import { Button } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setterInspector } from './store/slices/inspector-slice';

interface IButtonAdd {
    modelName: keyof StoreModelType;
    disabled?: boolean;
    size?: SizeType;
    caption?: string;
    parentNode?: any;
    parentData?: any;
    parentModelName?: string;
    icon?: React.ReactNode;
    minWidth?: string;
}

export const ButtonAdd: React.FC<IButtonAdd> = ({
    caption,
    modelName,
    size,
    parentNode,
    parentData,
    parentModelName,
    disabled = false,
    icon,
    minWidth,
}) => {
    const dispatch = useDispatch();

    const onClick = useCallback((e: any) => {
        e.stopPropagation();
        dispatch(setterInspector({ nameNewEntity: modelName, parentNode, parentModelName, parentData }));
    }, []);

    return (
        <Button
            type={'primary'}
            disabled={disabled}
            style={{ minWidth: minWidth || '80px', borderRadius: '50px' }}
            onClick={onClick}
            size={size}
        >
            {icon || <PlusOutlined />}
            {caption}
        </Button>
    );
};
